import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { AppService } from '../core/services/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { toggleAnimation } from '@sukna/shared';
import { NgClass, NgComponentOutlet, AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { IconMenuComponent, IconSearchComponent, IconSunComponent, IconMoonComponent, IconLaptopComponent, IconLogoutComponent, IconCaretDownComponent, SearchInputComponent } from '@sukna/shared';
import { MenuModule } from 'headlessui-angular';
import { navMenuList } from '../shared/constants';
import { HasPermissionDirective } from '@sukna/shared';
import { AuthService } from '../core/services/api/auth.service';
import { ListPageSearchService } from '../core/services/list-page-search.service';

@Component({
    selector: 'header',
    templateUrl: './header.html',
    animations: [toggleAnimation],
    imports: [
        NgClass,
        NgComponentOutlet,
        TranslatePipe, 
        MenuModule,
        RouterModule,
        IconMenuComponent,
        IconSearchComponent,
        IconLaptopComponent,
        IconSunComponent,
        IconMoonComponent,
        SearchInputComponent,
        IconLogoutComponent,
        IconCaretDownComponent,
        HasPermissionDirective,
        AsyncPipe
    ],
})
export class HeaderComponent implements OnInit {

    store: any;
    search = false;
    /** Temporary: set true when global list search is ready. */
    showGlobalSearch = false;
    headerSearchQuery = '';
    navMenuList = navMenuList;
    user$: Observable<any>;
    notifications = [
        {
            id: 1,
            profile: 'user-profile.jpeg',
            message: '<strong class="text-sm mr-1">John Doe</strong>invite you to <strong>Prototyping</strong>',
            time: '45 min ago',
        },
        {
            id: 2,
            profile: 'profile-34.jpeg',
            message: '<strong class="text-sm mr-1">Adam Nolan</strong>mentioned you to <strong>UX Basics</strong>',
            time: '9h Ago',
        },
        {
            id: 3,
            profile: 'profile-16.jpeg',
            message: '<strong class="text-sm mr-1">Anna Morgan</strong>Upload a file',
            time: '9h Ago',
        },
    ];
    messages: any[] = [];

    constructor(
        private _authService: AuthService,
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private appSetting: AppService,
        private sanitizer: DomSanitizer,
        private listPageSearch: ListPageSearchService,
    ) {
        this.initStore();
        this.user$ = this.storeData.select((state: any) => state.auth?.user);
        this.listPageSearch.changes$.subscribe((term) => {
            this.headerSearchQuery = term;
        });

        this.messages = [
            {
                id: 1,
                image: this.sanitizer.bypassSecurityTrustHtml(
                    `<span class="grid place-content-center w-9 h-9 rounded-full bg-success-light dark:bg-success text-success dark:text-success-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></span>`,
                ),
                title: 'Congratulations!',
                message: 'Your OS has been updated.',
                time: '1hr',
            },
            {
                id: 2,
                image: this.sanitizer.bypassSecurityTrustHtml(
                    `<span class="grid place-content-center w-9 h-9 rounded-full bg-info-light dark:bg-info text-info dark:text-info-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`,
                ),
                title: 'Did you know?',
                message: 'You can switch between artboards.',
                time: '2hr',
            },
            {
                id: 3,
                image: this.sanitizer.bypassSecurityTrustHtml(
                    `<span class="grid place-content-center w-9 h-9 rounded-full bg-danger-light dark:bg-danger text-danger dark:text-danger-light"> <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>`,
                ),
                title: 'Something went wrong!',
                message: 'Send Reposrt',
                time: '2days',
            },
            {
                id: 4,
                image: this.sanitizer.bypassSecurityTrustHtml(
                    `<span class="grid place-content-center w-9 h-9 rounded-full bg-warning-light dark:bg-warning text-warning dark:text-warning-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">    <circle cx="12" cy="12" r="10"></circle>    <line x1="12" y1="8" x2="12" y2="12"></line>    <line x1="12" y1="16" x2="12.01" y2="16"></line></svg></span>`,
                ),
                title: 'Warning',
                message: 'Your password strength is low.',
                time: '5days',
            },
        ];
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.setActiveDropdown();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
            }
        });
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    removeNotification(value: number) {
        this.notifications = this.notifications.filter((d) => d.id !== value);
    }

    removeMessage(value: number) {
        this.messages = this.messages.filter((d) => d.id !== value);
    }

    changeLanguage(item: any) {
        // Persist locale before reload so boot loads sa.json + Resources with Accept-Language: sa.
        this.appSetting.toggleLanguage(item);
        window.location.reload();
    }

    toggleTheme(theme: string) {
        this.storeData.dispatch({ type: 'toggleTheme', payload: theme });
    }

    logout() {
        this._authService.logout()
    }

    onHeaderSearch(term: string): void {
        this.listPageSearch.setTerm(term ?? '');
    }
}
